import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox, faTruck, faWarehouse, faBox, faCheck } from "@fortawesome/free-solid-svg-icons";
import styles from '../../styles/app/TrackingWidget.module.css';

const TrackingWidget: React.FC = () => {
    const navigate = useNavigate();
    const [trackingNumber, setTrackingNumber] = useState("");

    const handleTrack = () => {
        if (trackingNumber.trim()) {
            navigate(`/track?tracking=${encodeURIComponent(trackingNumber.trim())}`);
        }
    };

    const steps = [
        { label: 'Recibido', icon: faInbox, active: true },
        { label: 'En tránsito', icon: faTruck, active: true, current: true },
        { label: 'En aduana', icon: faWarehouse, active: false },
        { label: 'En entrega', icon: faBox, active: false },
        { label: 'Entregado', icon: faCheck, active: false },
    ];

    return (
        <div className={styles["tracking-widget"]}>
            <h3 className={styles["tracking-title"]}>Rastrea tu paquete</h3>
            <p className={styles["tracking-subtitle"]}>Consulta el estado de tu envío en tiempo real</p>

            <div className={styles["tracking-input-group"]}>
                <input
                    type="text"
                    placeholder="Ej: 12999AA1234567890"
                    value={trackingNumber}
                    onChange={(e) => setTrackingNumber(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleTrack()}
                    className={styles["tracking-input"]}
                />
                <button className={styles["tracking-btn"]} onClick={handleTrack}>
                    Rastrear
                </button>
            </div>

            <div className={styles["tracking-steps-container"]}>
                <div className={styles["tracking-steps-line"]}>
                    <div className={styles["tracking-steps-line-progress"]} style={{ width: '25%' }}></div>
                </div>
                <div className={styles["tracking-steps"]}>
                    {steps.map((step, idx) => (
                        <div key={idx} className={`${styles["tracking-step"]} ${step.active ? styles["active"] : ''} ${step.current ? styles["current"] : ''}`}>
                            <div className={styles["step-icon-wrapper"]}>
                                <FontAwesomeIcon icon={step.icon} />
                            </div>
                            <span className={styles["step-label"]}>{step.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TrackingWidget;


